import { render, staticRenderFns } from "./AppRefreshButton.vue?vue&type=template&id=5ad8c060&scoped=true&"
import script from "./AppRefreshButton.vue?vue&type=script&lang=js&"
export * from "./AppRefreshButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad8c060",
  null
  
)

export default component.exports